<template>
  <busy-area :busy="loadingHistoryDifference">
    <h2>{{ fullTitle }}</h2>
    <div class="flex flex-wrap gap-x-10 gap-y-10 pb-10 pt-5">
      <div class="flex flex-col justify-stretch">
        <table class="statisticsTable h-full">
          <thead>
            <tr>
              <th>{{ $t('pages.history.property') }}</th>
              <th>{{ $t('pages.history.value') }}</th>
              <th>{{ $t('pages.history.property') }}</th>
              <th>{{ $t('pages.history.value') }}</th>
              <th>{{ $t('pages.history.property') }}</th>
              <th>{{ $t('pages.history.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ $t('pages.history.difference.driversCount') }}</td>
              <td>{{ historyDifferenceItem?.count }}</td>
              <td>{{ $t('pages.history.difference.driversDeleted') }}</td>
              <td>{{ historyDifferenceItem?.countDeleted }}</td>
              <td>{{ $t('pages.history.difference.driversEquipped') }}</td>
              <td>{{ historyDifferenceItem?.countEquipped }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.history.difference.driversV1Box') }}</td>
              <td>{{ historyDifferenceItem?.countV1Box }}</td>
              <td>{{ $t('pages.history.difference.driversV2Box') }}</td>
              <td>{{ historyDifferenceItem?.countV2Box }}</td>
              <td>{{ $t('pages.history.difference.driversInitialBox') }}</td>
              <td>{{ historyDifferenceItem?.countInitialBox }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.history.difference.driversReturnedBox') }}</td>
              <td>{{ historyDifferenceItem?.countReturnedBox }}</td>
              <td>{{ $t('pages.history.difference.driversLostBox') }}</td>
              <td>{{ historyDifferenceItem?.countLostBox }}</td>
              <td>{{ $t('pages.history.difference.driversDestroyedBox') }}</td>
              <td>{{ historyDifferenceItem?.countDestroyedBox }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.history.difference.driversMountedBox') }}</td>
              <td>{{ historyDifferenceItem?.countMountedBox }}</td>
              <td>{{ $t('pages.history.difference.driversOtherBox') }}</td>
              <td>{{ historyDifferenceItem?.countOtherBox }}</td>
              <td>{{ $t('pages.history.difference.driversBoxVarSocket') }}</td>
              <td>{{ historyDifferenceItem?.countBoxVarSocket }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.history.difference.driversV2InitialBox') }}</td>
              <td>{{ historyDifferenceItem?.countV2InitialBox }}</td>
              <td>{{ $t('pages.history.difference.driversV2ReturnedBox') }}</td>
              <td>{{ historyDifferenceItem?.countV2ReturnedBox }}</td>
              <td>{{ $t('pages.history.difference.driversV2LostBox') }}</td>
              <td>{{ historyDifferenceItem?.countV2LostBox }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.history.difference.driversV2DestroyedBox') }}</td>
              <td>{{ historyDifferenceItem?.countV2DestroyedBox }}</td>
              <td>{{ $t('pages.history.difference.driversV2MountedBox') }}</td>
              <td>{{ historyDifferenceItem?.countV2MountedBox }}</td>
              <td>{{ $t('pages.history.difference.driversV2OtherBox') }}</td>
              <td>{{ historyDifferenceItem?.countV2OtherBox }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.history.difference.driversBoxVarNoSocket') }}</td>
              <td>{{ historyDifferenceItem?.countBoxVarNoSocket }}</td>
              <td>{{ $t('pages.history.difference.driversBoxVarUnknown') }}</td>
              <td>{{ historyDifferenceItem?.countBoxVarUnknown }}</td>
              <td>{{ }}</td>
              <td>{{ }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.history.difference.driversPhase1') }}</td>
              <td>{{ historyDifferenceItem?.countPhase1 }}</td>
              <td>{{ $t('pages.history.difference.driversPhase2') }}</td>
              <td>{{ historyDifferenceItem?.countPhase2 }}</td>
              <td>{{ $t('pages.history.difference.driversPhase3') }}</td>
              <td>{{ historyDifferenceItem?.countPhase3 }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.history.difference.driversPhase0') }}</td>
              <td>{{ historyDifferenceItem?.countPhase0 }}</td>
              <td>{{ $t('pages.history.difference.driversCountIncompleteBusiness') }}</td>
              <td>{{ historyDifferenceItem?.countIncompleteBusiness }}</td>
              <td>{{ $t('pages.history.difference.driversCountIncompleteStandard') }}</td>
              <td>{{ historyDifferenceItem?.countIncompleteStandard }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.history.difference.driversBtRace') }}</td>
              <td>{{ historyDifferenceItem?.countBtRace }}</td>
              <td>{{ $t('pages.history.difference.driversBtSingleSpeed') }}</td>
              <td>{{ historyDifferenceItem?.countBtSingleSpeed }}</td>
              <td>{{ $t('pages.history.difference.driversBtCityBike') }}</td>
              <td>{{ historyDifferenceItem?.countBtCityBike }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.history.difference.driversBtECityBike') }}</td>
              <td>{{ historyDifferenceItem?.countBtECityBike }}</td>
              <td>{{ $t('pages.history.difference.driversBtEMountainBike') }}</td>
              <td>{{ historyDifferenceItem?.countBtEMountainBike }}</td>
              <td>{{ '' }}</td>
              <td>{{ }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </busy-area>
</template>

<script lang="ts" setup>
import BusyArea from '@utils/busy/BusyArea.vue';
import { format } from 'date-fns';
import { useI18n } from 'vue-i18n';
import { useProvider } from '@utils/table/hooks/provider';
import { computed } from 'vue';
import type { DriverHistoryType, Region } from '@/entities/Entities';

export interface HistoryDriverDifferenceDto {
  startDate?: Date;
  endDate?: Date;
  region: Region | null;
  driverType: DriverHistoryType;
  count: number;
  countDeleted: number;
  countEquipped: number;
  countV1Box: number;
  countV2Box: number;
  countInitialBox: number;
  countReturnedBox: number;
  countLostBox: number;
  countDestroyedBox: number;
  countMountedBox: number;
  countOtherBox: number;
  countBoxVarSocket: number;
  countBoxVarNoSocket: number;
  countBoxVarUnknown: number;
  countPhase1: number;
  countPhase2: number;
  countPhase3: number;
  countPhase0: number;
  countBtRace: number;
  countBtSingleSpeed: number;
  countBtCityBike: number;
  countBtECityBike: number;
  countBtEMountainBike: number;
  countV2InitialBox: number;
  countV2ReturnedBox: number;
  countV2LostBox: number;
  countV2DestroyedBox: number;
  countV2MountedBox: number;
  countV2OtherBox: number;
  countIncompleteBusiness: number;
  countIncompleteStandard: number;
}

interface Props {
  providerParams: object;
}

const { t } = useI18n();

const props = defineProps<Props>();

const {
  data: historyDifferenceItem,
  loading: loadingHistoryDifference,
} = useProvider<HistoryDriverDifferenceDto>('/history_drivers/difference', props.providerParams);

function formatDate(date: Date | undefined) {
  return date && format(new Date(date), 'dd.MM.yyyy - HH:mm:ss');
}

const regionTitle = computed(() => {
  const regionName = historyDifferenceItem.value?.region?.name;
  if (regionName) {
    return `${t('pages.history.difference.title.forRegion')} ${regionName}`;
  }
  return `${t('pages.history.difference.title.forAllRegions')}`;
});

const fullTitle = computed(() => {
  const startDate = formatDate(historyDifferenceItem.value?.startDate);
  const endDate = formatDate(historyDifferenceItem.value?.endDate);
  // eslint-disable-next-line max-len
  return `${t('pages.history.difference.title.differenceFrom')} ${startDate} ${t('pages.history.difference.title.to')} ${endDate} ${regionTitle.value}`;
});

</script>

<style lang="scss" scoped>
.statisticsTable {
  @apply border;

  tr {
    td, th {
      &:not(:last-child) {
        @apply border-r;
      }

      @apply px-5 py-2;
      text-align: right;
    }

    th {
      @apply border-b;
    }
  }
}
</style>
